import { Injectable, Inject } from '@angular/core';
import { AuthService } from './auth.service';


@Injectable()
export class QRCodeService {

  constructor(@Inject('BASE_URL') private baseUrl: string
    , private authService: AuthService) {

  }

  get currentQrCode(): string {
    if (this.authService.getUserName()) {
      const url = this.authService.getMobileScannApi() == null 
        ? this.baseUrl
        : this.authService.getMobileScannApi();
      return url + '|' + this.authService.getMobileLinkId();
    } else {
      return null;
    }
  }
}
